export enum MeasuringPointLogLevel {
    verbose = "verbose",
    info = "info",
    warning = "warning",
    error = "error",
    clear = "clear",
}
